import { newToast } from '../components';
import { Profile } from '../types/types.user';
import useApi from '../utils/axios-pettitions';

export const useApiConfigUsuarios = () => {
  const { runApi } = useApi();

  const getUsuarios = async () => {
    return runApi('Configuration/getUsuarios', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getSimpleUsuarios = async () => {
    return runApi('Configuration/GetSimpleUsuarios', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const generateTokenForUser = async (IdUser: number) => {
    return runApi('Authentication/GenerateToken', 'POST', { IdUser }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return null;
    });
  };

  const getUsuariosById = async (IdUser) => {
    return runApi('Configuration/getUserById', 'GET', { IdUser }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newUser = async ({ User }) => {
    return runApi('configuration/newUser', 'POST', null, User).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setUser = async ({ User, IdUser }) => {
    return runApi('Configuration/putUser', 'POST', { IdUser }, User).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deleteUser = async ({ Id }) => {
    return runApi('Configuration/deleteUser', 'POST', { Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return res.httpCode;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getPerfiles = async () => {
    return runApi('configuration/getUsuariosPerfiles', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const newPerfil = async (data: Profile) => {
    return runApi('configuration/newUsuarioPerfil', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setPerfiles = async (Perfil) => {
    return runApi('Configuration/putUsuarioPerfil', 'POST', null, Perfil).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const deletePerfil = async ({ IdPerfil }) => {
    return runApi('Configuration/deleteUsuarioPerfil', 'POST', { IdPerfil }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const setPermisos = async ({ Permiso }) => {
    return runApi('Configuration/putUsuarioPermisos', 'POST', null, Permiso).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return res.httpCode;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.internalCode;
      }
      return -1;
    });
  };

  const getPermisos = async (IdPermiso: number) => {
    return runApi('Configuration/getUsuarioPermiso', 'GET', { IdPermiso }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return {};
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return {};
    });
  };

  const GetLocationByUser = async (idUser) => {
    return runApi('Authentication/GetLocationByUser', 'GET', { idUser }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return {};
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return {};
    });
  };

  const AddLocationToUser = async (idUser, Rus_Sd_Id) => {
    return runApi('Authentication/AddLocationToUser', 'POST', { idUser, idLocation:Rus_Sd_Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return { success: false };
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return { success: true };
      }
      return { success: false };
    });
  };

  const DeleteLocationFromUser = async (idUser, Rus_Sd_Id) => {
    return runApi('Authentication/DeleteLocationFromUser', 'POST', { idUser, idLocation: Rus_Sd_Id }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return { success: false };
      } else if (res.internalCode === 108) {
        newToast('SUCCESS', res.message, 3);
        return { success: true };
      }
      return { success: false };
    });
  };

  const changePassword = async (data) => {
    return runApi('Configuration/changePassword', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.messageDetails, 5);
        return true;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.messageDetails, 5);
        return false;
      }
      return false;
    });
  };

  return {
    getPerfiles,
    newPerfil,
    setPerfiles,
    getPermisos,
    setPermisos,
    getUsuarios,
    getSimpleUsuarios,
    getUsuariosById,
    newUser,
    setUser,
    deleteUser,
    deletePerfil,
    changePassword,
    generateTokenForUser,
    GetLocationByUser
    ,AddLocationToUser
    ,DeleteLocationFromUser
  };
};
